import { render, staticRenderFns } from "./AddWorkHours.vue?vue&type=template&id=22057c55&"
import script from "./AddWorkHours.vue?vue&type=script&lang=js&"
export * from "./AddWorkHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports